var map = {
	"./404.jpeg": 161,
	"./IXP-android-scan-code.png": 267,
	"./activate-user-banner.png": 162,
	"./active-user-qr.png": 268,
	"./aicte-logo.png": 269,
	"./app-store.svg": 270,
	"./appleplay-store.png": 163,
	"./blog_post_detail.png": 271,
	"./brand-logo.png": 272,
	"./brandlogo.png": 273,
	"./bulk_batch_assign.csv": 137,
	"./bulk_password.csv": 164,
	"./bulk_question_create.csv": 165,
	"./bulk_student_create.csv": 166,
	"./cilogo.jpg": 167,
	"./close-arrow.svg": 168,
	"./common-footerQR.png": 169,
	"./contacts-icon.png": 140,
	"./content-lib.png": 141,
	"./content.svg": 170,
	"./courses.svg": 142,
	"./create_group_student.csv": 171,
	"./dialog-close.png": 274,
	"./down-arrow.png": 172,
	"./dps-logo.png": 275,
	"./element1.svg": 276,
	"./empty.png": 277,
	"./empty.svg": 128,
	"./error.svg": 173,
	"./exit-screen.svg": 174,
	"./facebook-icon.png": 148,
	"./favicon.ico": 278,
	"./favicon.svg": 279,
	"./full-screen.svg": 175,
	"./googleplay-store.svgz": 176,
	"./home1.svg": 280,
	"./home2.svg": 281,
	"./home3.svg": 282,
	"./home4.svg": 283,
	"./imaginxp-gamebanner.jpg": 284,
	"./imaginxp-loginbanner-1.jpg": 177,
	"./imaginxp-loginbanner-2.jpg": 178,
	"./imaginxp-loginbanner-3.jpg": 179,
	"./imaginxp-loginbanner-4.jpg": 180,
	"./imaginxp-loginbanner-5.jpg": 181,
	"./imaginxp-logo.png": 285,
	"./img-holder.svg": 131,
	"./insightu-logo.png": 286,
	"./instagram-icon.png": 149,
	"./learner_blogpost.png": 287,
	"./learnfest-sessions-thumb1.jpg": 288,
	"./learnfest-sessions-thumb10.jpg": 289,
	"./learnfest-sessions-thumb11.jpg": 290,
	"./learnfest-sessions-thumb2.jpg": 291,
	"./learnfest-sessions-thumb3.jpg": 292,
	"./learnfest-sessions-thumb4.jpg": 293,
	"./learnfest-sessions-thumb5.jpg": 294,
	"./learnfest-sessions-thumb6.jpg": 295,
	"./learnfest-sessions-thumb7.jpg": 296,
	"./learnfest-sessions-thumb8.jpg": 297,
	"./learnfest-sessions-thumb9.jpg": 298,
	"./linkedin-icon.png": 150,
	"./login-banner1.jpg": 299,
	"./login-banner2.jpg": 300,
	"./login-banner3.jpg": 301,
	"./login-banner4.jpg": 302,
	"./mark-attendance-icon.png": 182,
	"./model-banner.jpg": 143,
	"./my-percentage-coming-soon-banner.jpg": 183,
	"./noesis.svg": 303,
	"./nothing-to-show.png": 184,
	"./open-arrow.svg": 185,
	"./play-store.svg": 304,
	"./questionoftheday-bg.png": 186,
	"./questionoftheday-header.svg": 187,
	"./referral-rightbg.jpg": 305,
	"./referral-rightbg.png": 306,
	"./referral-rightbg1.png": 307,
	"./reportsCheckBoxTick.png": 308,
	"./sastra-login-banner1.jpg": 309,
	"./sastra-login-banner2.jpg": 310,
	"./sastra-login-banner3.jpg": 311,
	"./sastra-login-banner4.jpg": 312,
	"./sastra-logo.png": 313,
	"./sastra-logo1.png": 314,
	"./scancode-banner.png": 188,
	"./search-icon.png": 315,
	"./searching-page-herobg.jpg": 316,
	"./signup-bg.png": 317,
	"./signup-slider1.png": 318,
	"./signup-slider2.png": 319,
	"./signup-slider3.png": 320,
	"./skyed-logo.png": 321,
	"./sm-lib.svg": 151,
	"./sow-login-banner1.png": 189,
	"./sow-login-banner2.png": 190,
	"./sow-login-banner3.png": 191,
	"./sow-login-banner4.png": 192,
	"./sow-logo.png": 322,
	"./sow-sectio-3shape.svg": 323,
	"./sow-section-2-icon1.png": 324,
	"./sow-section-2-icon2.png": 325,
	"./sow-section-2-icon3.png": 326,
	"./sow-section-2-icon4.png": 327,
	"./sow-section-2bg.svg": 328,
	"./sow-section-3-administration.svg": 329,
	"./sow-section-3-list-bullet.png": 330,
	"./sow-section-3-list-symbol.png": 331,
	"./sow-section-3-list-symbol2.png": 332,
	"./sow-section-3-parents.svg": 333,
	"./sow-section-3-student.svg": 334,
	"./sow-section-3-teacher.svg": 335,
	"./sow-section-4-banner.svg": 336,
	"./sow-section-5-banner.svg": 337,
	"./sow-section-6-banner.svg": 338,
	"./sow-section-7-banner.svg": 339,
	"./sow-section-8-banner.svg": 340,
	"./ugpg-banner.png": 341,
	"./ugpgBanner1.png": 193,
	"./ugpgBanner2.png": 194,
	"./ugpgBanner3.png": 195,
	"./veranda-innovation.png": 342,
	"./veranda-login-banner1.jpg": 343,
	"./veranda-login-banner2.jpg": 344,
	"./veranda-login-banner3.jpg": 345,
	"./veranda-login-banner4.jpg": 346,
	"./veranda-logo.png": 347,
	"./vgu-login-banner1.jpg": 348,
	"./vgu-login-banner1.png": 349,
	"./vgu-login-banner2.jpg": 350,
	"./vgu-login-banner3.jpg": 351,
	"./vgu-login-banner4.jpg": 352,
	"./vgu-logo.jpg": 353,
	"./vgu-logo.png": 354,
	"./vgu-logo1.jpg": 144,
	"./xp-banner1.jpg": 355,
	"./xp-banner2.jpg": 356,
	"./xp-banner3.jpg": 357,
	"./xp-banner4.jpg": 358,
	"./xp-banner5.jpg": 359,
	"./xp-banner6.jpg": 360
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 136;